import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { BsQuote } from 'react-icons/bs';

const testimonials = [
  {
    id: 1,
    quote: "You won't regret it. I can't say enough about web service. It's the <span className='text-primary'>perfect solution for our business.</span>",
    content: "This is where you create powerful, progressive change. Notice the sense of freedom in your thoughts, the sense of accomplishment and Walkout 10 years into your future.",
    name: "Scarlett D.",
    position: "Manager",
    avatar: "images/avatar/02.jpg",
  },
  {
    id: 2,
    quote: "University impressed me on multiple levels. I wish I would have <span className='text-primary'>thought of it first.</span>",
    content: "They are intentional because these changes are changes that you are choosing and they are the changes that will cause you to live the life you want to live and dream.",
    name: "Hali D.",
    position: "Marketing Expert",
    avatar: "images/avatar/05.jpg",
  },
  {
    id: 3,
    quote: "Thanks guys, keep up the good work! I didn't <span className='text-primary'>even need training.</span>",
    content: "They often mean leaving the perception of security in order to discover your personal freedom. These are the changes that will bring happiness and satisfaction into your life. Just go there now.",
    name: "Sumner N.",
    position: "Team Leader",
    avatar: "images/avatar/03.jpg",
  },
];

const TestimonialSlider = () => {
  return (
    <section className="space-ptb bg-white">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Swiper
              className="testimonial-center"
              modules={[Pagination]}
              pagination={{ clickable: true }}
              slidesPerView={1}
              spaceBetween={0}
              autoHeight={true}
            >
              {testimonials.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                  <div className="item">
                    <div className="testimonial-item">
                      <div className="testimonial-quote text-center mb-4">
                         <BsQuote size={'80'} className='text-danger' />
                      </div>
                      <div className="text-center">
                        <h3 
                          className="mb-4" 
                          dangerouslySetInnerHTML={{ __html: testimonial.quote }}
                        />
                      </div>
                      <div className="testimonial-content">
                        <p>{testimonial.content}</p>
                      </div>
                      <div className="testimonial-author">
                        <div className="testimonial-avatar avatar avatar-md mr-0">
                          <img 
                            className="img-fluid" 
                            src={testimonial.avatar} 
                            alt={testimonial.name} 
                          />
                        </div>
                        <div className="testimonial-name">
                          <h5 className="name">{testimonial.name}</h5>
                          <span>- {testimonial.position}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;